export default __webpack_public_path__ + "ebccfd29417522436005f495b9c88615.png";